<div class="series-stage-panel--sponsor-fit series-stage-panel--stage">
  <h2>{{series.series}}</h2>
  <table class="series-stage-panel">
    <tr *ngFor="let stage of seriesStage" class="series-stage-panel__row">
      <td class="series-stage-panel__series series-stage-panel__cell">
        <a
          [href]="'//worldarchery.sport/competition/'+stage?.id.toString()"
          *ngIf="stage"
          class="series-stage-panel__series__link"
          data-th="name"
          >
          <span
            [ngClass]="'series-stage-panel__series__lastname'"
            >
            {{
              stage.stage === -1 ? 'Final' : 'STAGE '+ stage.stage
            }}:</span>
          <span> {{stage.place}},</span>
          <span
            >
            {{stage.countryName}}</span>
          <img class="series-stage-panel__series__flag" *ngIf="stage.country!==undefined"
            [lazyLoad]="
            '//extranet.worldarchery.sport/Flags/' +
            stage.country +
            '.svg'
            "
          />
          <span class="series-stage-panel__series-date">{{stage.dateFromObj|date : 'd LLLL'}} TO {{stage.dateToObj | date :'d LLLL'}}</span>
        </a>

      </td>
    </tr>

  </table>

</div>
